import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { path: '/employer/team', label: 'Team' },
  { path: '/employer/settings/notifications', label: 'Notifications' },
  { path: '/employer/settings/hiring', label: 'Hiring Preferences' },
  { path: '/employer/settings/billing', label: 'Billing' },
];

function SettingsNav() {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-wrap gap-2 mb-6 border-b border-purple-100 pb-3">
      {TABS.map((tab) => {
        const active = pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`px-4 py-2 text-sm font-semibold rounded-full transition-all duration-200 ${
              active
                ? 'bg-gradient-to-r from-[#5B2EFF] via-[#8B5CF6] to-[#FF4D8D] text-white shadow-md shadow-purple-500/25'
                : 'text-gray-500 hover:bg-purple-50 hover:text-[#7C3AED]'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}

export default SettingsNav;







// import { useState, useRef, useEffect } from 'react';
// import { useNavigate, Link } from 'react-router-dom';
// import planbLogo from '../assets/planb-logo.png';
// import api, { BACKEND_URL } from '../api/axios';
// import { SKILLS_LIST, JOB_TITLES_LIST, CITIES_LIST } from '../data/Autocompletedata';
// import { getStoredAttribution } from '../utils/Attribution';

// /* ============================================================================
//    PlanB Jobs — Conversational Registration (v2, visual pass)
//    ----------------------------------------------------------------------------
//    Same step machine as before; this pass is purely about making it look and
//    feel like a real product instead of a bare chat log — gradient backdrop,
//    a "device" frame for the conversation, colored icon-tiles for choices
//    (matching the reference mock's colored squares), a progress trail, and
//    entrance animation on each message.

//    Two backend gaps still apply (unchanged from before, still flagged inline):
//      1. Email + password — /register requires both; not in your original spec.
//      2. Current salary has no backend column — folded into experience
//         description text as a stopgap.
//    ============================================================================ */

// const OTP_LENGTH = 4; // matches existing OtpController
// const RESEND_SECONDS = 30;
// const MAX_LOCATIONS = 5;
// const MAX_PREVIOUS_EMPLOYERS = 3;

// const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
// const YEARS = Array.from({ length: 45 }, (_, i) => new Date().getFullYear() - i);

// // Icon-tile palette — cycles through these for quick-reply cards so choices
// // read as distinct, tappable objects rather than plain outlined buttons.
// const TILE_STYLES = [
//   { bg: 'from-[#2563EB] to-[#3B82F6]' },
//   { bg: 'from-[#E3242B] to-[#F0455A]' },
//   { bg: 'from-[#10B981] to-[#34D399]' },
//   { bg: 'from-[#6B2A8C] to-[#8B5CF6]' },
// ];

// function uid() {
//   return Math.random().toString(36).slice(2, 10);
// }

// /* ---------------------------------------------------------------------- */
// /* Global keyframes (scoped via a plain <style> tag — no Tailwind config    */
// /* changes needed in the host project)                                     */
// /* ---------------------------------------------------------------------- */

// function GlobalStyles() {
//   return (
//     <style>{`
//       @keyframes rc-fade-up { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
//       @keyframes rc-pop { from { opacity: 0; transform: scale(0.92); } to { opacity: 1; transform: scale(1); } }
//       @keyframes rc-blob { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(20px,-15px) scale(1.05); } }
//       .rc-msg { animation: rc-fade-up 0.32s ease-out both; }
//       .rc-composer { animation: rc-pop 0.28s ease-out both; }
//       .rc-blob { animation: rc-blob 9s ease-in-out infinite; }
//     `}</style>
//   );
// }

// /* ---------------------------------------------------------------------- */
// /* Presentational bits                                                     */
// /* ---------------------------------------------------------------------- */

// function BotAvatar() {
//   return (
//     <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#0D1B3D] to-[#3B1F70] flex items-center justify-center shrink-0 shadow-sm">
//       <img src={planbLogo} alt="" style={{ width: 18, height: 18 }} className="object-contain brightness-0 invert" />
//     </div>
//   );
// }

// function BotBubble({ children }) {
//   return (
//     <div className="rc-msg flex items-end gap-2 mb-3 max-w-[88%]">
//       <BotAvatar />
//       <div className="bg-white border border-gray-100 shadow-[0_2px_10px_rgba(13,27,61,0.06)] rounded-2xl rounded-bl-sm px-4 py-2.5 text-sm text-[#0D1B3D] leading-relaxed">
//         {children}
//       </div>
//     </div>
//   );
// }

// function UserBubble({ children }) {
//   return (
//     <div className="rc-msg flex justify-end mb-3">
//       <div className="bg-gradient-to-br from-[#2563EB] to-[#3B82F6] text-white shadow-[0_4px_14px_rgba(37,99,235,0.28)] rounded-2xl rounded-br-sm px-4 py-2.5 text-sm max-w-[88%]">
//         {children}
//       </div>
//     </div>
//   );
// }

// function TypingBubble() {
//   return (
//     <div className="rc-msg flex items-end gap-2 mb-3">
//       <BotAvatar />
//       <div className="bg-white border border-gray-100 shadow-sm rounded-2xl rounded-bl-sm px-4 py-3 flex gap-1">
//         {[0, 1, 2].map((i) => (
//           <span key={i} className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: `${i * 120}ms` }} />
//         ))}
//       </div>
//     </div>
//   );
// }

// /* Colored icon-tile quick-reply card, matching the reference mock's style */
// function TileCard({ icon, title, subtitle, onClick, tileIndex = 0 }) {
//   const style = TILE_STYLES[tileIndex % TILE_STYLES.length];
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="flex-1 flex flex-col items-center gap-2 p-4 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 transition-all"
//     >
//       <span className={`w-11 h-11 rounded-xl bg-gradient-to-br ${style.bg} flex items-center justify-center text-lg shadow-sm`}>
//         {icon}
//       </span>
//       <span className="text-sm font-semibold text-[#0D1B3D] text-center">{title}</span>
//       {subtitle && <span className="text-[11px] text-gray-400 text-center">{subtitle}</span>}
//     </button>
//   );
// }

// function PillOption({ label, onClick, tileIndex = 0 }) {
//   const style = TILE_STYLES[tileIndex % TILE_STYLES.length];
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="group flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium border border-gray-200 bg-white hover:border-transparent hover:shadow-md transition-all"
//     >
//       <span className={`w-2 h-2 rounded-full bg-gradient-to-br ${style.bg}`} />
//       <span className="group-hover:text-[#0D1B3D]">{label}</span>
//     </button>
//   );
// }

// function Chip({ label, onRemove }) {
//   return (
//     <div className="bg-[#EFF6FF] text-[#2563EB] px-2.5 py-1.5 rounded-full text-sm font-semibold flex items-center gap-1.5 border border-[#2563EB]/10">
//       <span>{label}</span>
//       {onRemove && <button type="button" onClick={onRemove} className="leading-none opacity-60 hover:opacity-100">&times;</button>}
//     </div>
//   );
// }

// function PrimaryButton({ children, onClick, disabled }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       disabled={disabled}
//       className="w-full bg-gradient-to-r from-[#2563EB] to-[#3B82F6] text-white py-2.5 rounded-full font-semibold text-sm shadow-[0_4px_14px_rgba(37,99,235,0.3)] hover:shadow-[0_6px_18px_rgba(37,99,235,0.4)] hover:-translate-y-0.5 active:translate-y-0 transition-all disabled:opacity-50 disabled:shadow-none disabled:translate-y-0"
//     >
//       {children}
//     </button>
//   );
// }

// function TextComposer({ value, onChange, onSubmit, placeholder, type = 'text', autoFocus }) {
//   return (
//     <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }} className="flex items-center gap-2">
//       <input
//         type={type}
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         placeholder={placeholder}
//         autoFocus={autoFocus}
//         className="flex-1 border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition"
//       />
//       <button
//         type="submit"
//         disabled={!value?.toString().trim()}
//         className="w-10 h-10 rounded-full bg-gradient-to-br from-[#2563EB] to-[#3B82F6] text-white flex items-center justify-center shrink-0 shadow-md hover:scale-105 active:scale-95 transition disabled:opacity-40 disabled:hover:scale-100"
//       >
//         ➤
//       </button>
//     </form>
//   );
// }

// function InlineAutocomplete({ options, value, onChange, onSelect, placeholder }) {
//   const [open, setOpen] = useState(false);
//   const filtered = value?.trim().length > 0
//     ? options.filter((o) => o.toLowerCase().includes(value.toLowerCase())).slice(0, 6)
//     : [];
//   return (
//     <div className="relative">
//       <input
//         type="text"
//         value={value}
//         onChange={(e) => { onChange(e.target.value); setOpen(true); }}
//         onFocus={() => setOpen(true)}
//         onBlur={() => setTimeout(() => setOpen(false), 150)}
//         placeholder={placeholder}
//         autoFocus
//         className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition"
//       />
//       {open && filtered.length > 0 && (
//         <div className="absolute z-10 left-0 right-0 mt-1.5 bg-white border border-gray-100 rounded-2xl shadow-lg max-h-48 overflow-y-auto p-1.5">
//           {filtered.map((f) => (
//             <button
//               key={f}
//               type="button"
//               onMouseDown={() => onSelect(f)}
//               className="w-full text-left px-3.5 py-2.5 text-sm text-gray-700 hover:bg-[#EFF6FF] hover:text-[#2563EB] rounded-xl transition"
//             >
//               {f}
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ---------------------------------------------------------------------- */
// /* Step order — used only to compute progress-dot position                 */
// /* ---------------------------------------------------------------------- */

// function stepOrderFor(role, experienceLevel) {
//   const base = ['welcome', 'name', 'gender', 'phone', 'otp', 'account', 'role'];
//   if (role === 'employer') return [...base, 'employer_company', 'summary'];
//   if (experienceLevel === 'experienced') {
//     return [...base, 'exp_level', 'current_designation', 'current_salary', 'current_company',
//       'employment_period', 'prev_employer_choice', 'target_role', 'locations', 'skills', 'summary'];
//   }
//   return [...base, 'exp_level', 'looking_role', 'locations', 'skills', 'summary'];
// }

// /* ---------------------------------------------------------------------- */
// /* Main component                                                          */
// /* ---------------------------------------------------------------------- */

// function RegisterChat() {
//   const navigate = useNavigate();
//   const scrollRef = useRef(null);

//   const [messages, setMessages] = useState([
//     { id: uid(), from: 'bot', content: "👋 Hi! Welcome to PlanB Jobs." },
//     { id: uid(), from: 'bot', content: "Let's create your profile. It'll only take a few minutes." },
//   ]);
//   const [typing, setTyping] = useState(false);
//   const [step, setStep] = useState('welcome');
//   const [error, setError] = useState('');

//   const [form, setForm] = useState({
//     name: '', gender: '', phone: '', email: '', password: '', password_confirmation: '',
//     role: '', experienceLevel: '',
//     lookingForRole: '',
//     currentDesignation: '', currentSalary: '', salaryPeriod: 'year', currentCompany: '',
//     startMonth: '', startYear: '', currentlyWorking: true, endMonth: '', endYear: '',
//     hasPreviousEmployer: null, previousEmployers: [], targetRole: '',
//     locations: [], skills: [],
//     company_industry: '', company_size: '',
//   });

//   const [otpDigits, setOtpDigits] = useState(Array(OTP_LENGTH).fill(''));
//   const [otpToken, setOtpToken] = useState('');
//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [resendCooldown, setResendCooldown] = useState(0);
//   const otpRefs = useRef([]);

//   const [draft, setDraft] = useState('');
//   const [skillInput, setSkillInput] = useState('');
//   const [locInput, setLocInput] = useState('');
//   const [prevDraft, setPrevDraft] = useState({ company: '', designation: '', from: '', to: '' });
//   const [submitting, setSubmitting] = useState(false);

//   useEffect(() => {
//     scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: 'smooth' });
//   }, [messages, typing]);

//   useEffect(() => {
//     if (resendCooldown <= 0) return;
//     const t = setTimeout(() => setResendCooldown((s) => s - 1), 1000);
//     return () => clearTimeout(t);
//   }, [resendCooldown]);

//   const say = (content) => setMessages((m) => [...m, { id: uid(), from: 'bot', content }]);
//   const reply = (content) => setMessages((m) => [...m, { id: uid(), from: 'user', content }]);

//   const goTo = (nextStep, botLines) => {
//     setError('');
//     const lines = Array.isArray(botLines) ? botLines : botLines ? [botLines] : [];
//     if (lines.length === 0) { setStep(nextStep); return; }
//     setTyping(true);
//     setTimeout(() => {
//       setTyping(false);
//       lines.forEach((l) => say(l));
//       setStep(nextStep);
//     }, 450);
//   };

//   const set = (patch) => setForm((f) => ({ ...f, ...patch }));

//   /* ---------------- Step handlers (unchanged logic) ---------------- */

//   const handleGetStarted = () => {
//     reply('Get Started');
//     goTo('name', 'What should we call you?');
//   };
//   const submitName = () => {
//     if (!draft.trim()) return;
//     reply(draft); set({ name: draft.trim() }); setDraft('');
//     goTo('gender', 'What is your gender?');
//   };
//   const submitGender = (g) => {
//     reply(g); set({ gender: g });
//     goTo('phone', "What's your mobile number?");
//   };
//   const submitPhone = async () => {
//     if (!/^[6-9]\d{9}$/.test(draft)) { setError('Enter a valid 10-digit mobile number.'); return; }
//     reply(`+91 ${draft}`); set({ phone: draft });
//     const phone = draft; setDraft(''); setError('');
//     try {
//       const avail = await api.post('/auth/check-availability', { phone });
//       if (avail.data?.phone_exists) { say('An account with this mobile number already exists — try logging in instead.'); return; }
//     } catch (err) { console.warn('Availability check failed', err.response?.data || err.message); }
//     setSendingOtp(true);
//     try {
//       await api.post('/otp/send', { phone });
//       setOtpDigits(Array(OTP_LENGTH).fill(''));
//       setResendCooldown(RESEND_SECONDS);
//       goTo('otp', `We've sent a ${OTP_LENGTH}-digit OTP to +91 ${phone}`);
//     } catch (err) { say(err.response?.data?.message || "Couldn't send the OTP — please try again."); }
//     finally { setSendingOtp(false); }
//   };
//   const handleOtpDigit = (i, v) => {
//     const d = v.replace(/\D/g, '').slice(-1);
//     const next = [...otpDigits]; next[i] = d; setOtpDigits(next);
//     if (d && i < OTP_LENGTH - 1) otpRefs.current[i + 1]?.focus();
//   };
//   const handleOtpKeyDown = (i, e) => {
//     if (e.key === 'Backspace' && !otpDigits[i] && i > 0) otpRefs.current[i - 1]?.focus();
//   };
//   const submitOtp = async () => {
//     const otp = otpDigits.join('');
//     if (otp.length !== OTP_LENGTH) { setError(`Enter the ${OTP_LENGTH}-digit OTP.`); return; }
//     setVerifyingOtp(true); setError('');
//     try {
//       const res = await api.post('/otp/verify', { phone: form.phone, otp });
//       setOtpToken(res.data.otp_token || res.data.token || '');
//       reply(otp.split('').join(' '));
//       goTo('account', ['✅ Mobile number verified!', "Now let's set up your account login — email and a password."]);
//     } catch (err) { setError(err.response?.data?.message || 'Incorrect OTP. Please try again.'); }
//     finally { setVerifyingOtp(false); }
//   };
//   const handleResendOtp = async () => {
//     if (resendCooldown > 0 || sendingOtp) return;
//     setSendingOtp(true);
//     try {
//       await api.post('/otp/send', { phone: form.phone });
//       setOtpDigits(Array(OTP_LENGTH).fill(''));
//       setResendCooldown(RESEND_SECONDS);
//       otpRefs.current[0]?.focus();
//     } catch (err) { setError(err.response?.data?.message || 'Could not resend OTP.'); }
//     finally { setSendingOtp(false); }
//   };
//   const submitAccount = async () => {
//     const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
//     if (!emailValid) return setError('Enter a valid email address.');
//     if (form.password.length < 8) return setError('Password must be at least 8 characters.');
//     if (form.password !== form.password_confirmation) return setError('Passwords do not match.');
//     setError('');
//     try {
//       const avail = await api.post('/auth/check-availability', { email: form.email });
//       if (avail.data?.email_exists) { setError('An account with this email already exists. Please login instead.'); return; }
//     } catch (err) { console.warn('Email availability check failed', err.response?.data || err.message); }
//     reply(form.email);
//     goTo('role', 'What are you looking for on PlanB Jobs?');
//   };
//   const submitRole = (role) => {
//     reply(role === 'job_seeker' ? "I'm looking for a Job" : "I'm hiring");
//     set({ role });
//     if (role === 'employer') goTo('employer_company', "Great — a couple of quick details about your company.");
//     else goTo('exp_level', ["Great! Let's build your job profile.", 'Are you a fresher or do you have work experience?']);
//   };
//   const submitExpLevel = (level) => {
//     reply(level === 'fresher' ? 'Fresher' : 'Experienced');
//     set({ experienceLevel: level });
//     if (level === 'fresher') goTo('looking_role', 'What type of role are you looking for?');
//     else goTo('current_designation', 'What is your current / most recent designation?');
//   };
//   const submitLookingRole = (v) => {
//     reply(v); set({ lookingForRole: v });
//     goTo('locations', [`Where would you like to work?`, `You can add up to ${MAX_LOCATIONS} cities.`]);
//   };
//   const submitCurrentDesignation = (v) => {
//     reply(v); set({ currentDesignation: v });
//     goTo('current_salary', 'What is your current / last salary?');
//   };
//   const submitCurrentSalary = () => {
//     if (!draft.trim()) return;
//     reply(`₹${draft} / ${form.salaryPeriod === 'year' ? 'year' : 'month'}`);
//     set({ currentSalary: draft.trim() }); setDraft('');
//     goTo('current_company', 'Which company do you currently work for?');
//   };
//   const submitCurrentCompany = (v) => {
//     reply(v); set({ currentCompany: v });
//     goTo('employment_period', 'When did you start working here?');
//   };
//   const submitEmploymentPeriod = () => {
//     if (!form.startMonth || !form.startYear) { setError('Please add a start month and year.'); return; }
//     if (!form.currentlyWorking && (!form.endMonth || !form.endYear)) { setError('Please add an end month and year, or mark this as your current job.'); return; }
//     setError('');
//     const label = `${form.startMonth} ${form.startYear} → ${form.currentlyWorking ? 'Present' : `${form.endMonth} ${form.endYear}`}`;
//     reply(label);
//     goTo('prev_employer_choice', 'Do you have previous work experience?');
//   };
//   const submitPrevChoice = (yes) => {
//     reply(yes ? 'Yes, add previous employer' : 'No, continue');
//     set({ hasPreviousEmployer: yes });
//     if (yes) { setPrevDraft({ company: '', designation: '', from: '', to: '' }); goTo('prev_employer_add', `Previous employer ${form.previousEmployers.length + 1}`); }
//     else goTo('target_role', 'What type of role are you looking for next?');
//   };
//   const submitPrevEmployer = () => {
//     const { company, designation, from, to } = prevDraft;
//     if (!company.trim() || !designation.trim()) { setError('Add at least a company name and designation.'); return; }
//     setError('');
//     const entry = { company: company.trim(), designation: designation.trim(), from: from.trim(), to: to.trim() };
//     set({ previousEmployers: [...form.previousEmployers, entry] });
//     reply(`${entry.designation} at ${entry.company}${entry.from ? ` (${entry.from} – ${entry.to || 'Present'})` : ''}`);
//     if (form.previousEmployers.length + 1 >= MAX_PREVIOUS_EMPLOYERS) {
//       goTo('target_role', ["That's the max for now — you can add more later from your profile.", 'What type of role are you looking for next?']);
//     } else {
//       goTo('prev_employer_more', 'Add another previous employer?');
//     }
//   };
//   const submitPrevMore = (yes) => {
//     reply(yes ? '+ Add another' : 'Continue');
//     if (yes) { setPrevDraft({ company: '', designation: '', from: '', to: '' }); goTo('prev_employer_add', `Previous employer ${form.previousEmployers.length + 1}`); }
//     else goTo('target_role', 'What type of role are you looking for next?');
//   };
//   const submitTargetRole = (v) => {
//     reply(v); set({ targetRole: v });
//     goTo('locations', [`Which cities would you prefer for your next job?`, `Select up to ${MAX_LOCATIONS} cities.`]);
//   };
//   const addLocation = (v) => {
//     if (!v.trim() || form.locations.includes(v.trim()) || form.locations.length >= MAX_LOCATIONS) return;
//     set({ locations: [...form.locations, v.trim()] }); setLocInput('');
//   };
//   const removeLocation = (i) => set({ locations: form.locations.filter((_, idx) => idx !== i) });
//   const submitLocations = () => {
//     if (form.locations.length === 0) { setError('Add at least one city.'); return; }
//     setError(''); reply(form.locations.join(', '));
//     goTo('skills', form.role === 'job_seeker' ? 'What skills do you have?' : undefined);
//   };
//   const addSkill = (v) => {
//     if (!v.trim() || form.skills.includes(v.trim())) return;
//     set({ skills: [...form.skills, v.trim()] }); setSkillInput('');
//   };
//   const removeSkill = (i) => set({ skills: form.skills.filter((_, idx) => idx !== i) });
//   const submitSkills = () => {
//     if (form.skills.length === 0) { setError('Add at least one skill.'); return; }
//     setError(''); reply(form.skills.join(', '));
//     goTo('summary');
//   };
//   const submitEmployerCompany = () => {
//     if (!form.company_industry.trim() || !form.company_size) { setError('Add your industry and company size.'); return; }
//     setError(''); reply(`${form.company_industry} · ${form.company_size}`);
//     goTo('summary');
//   };

//   const completeProfile = async () => {
//     setSubmitting(true); setError('');
//     try {
//       const attribution = getStoredAttribution();
//       const res = await api.post('/register', {
//         name: form.name, email: form.email, password: form.password, password_confirmation: form.password_confirmation,
//         phone: form.phone, role: form.role, otp_token: otpToken, otp_verified_via: 'phone',
//         ...(attribution ? { attribution } : {}),
//       });
//       localStorage.setItem('token', res.data.token);
//       localStorage.setItem('user', JSON.stringify(res.data.user));

//       if (form.role === 'employer') {
//         try {
//           await api.put('/profile', { company_industry: form.company_industry, company_size: form.company_size });
//         } catch (e) { console.warn('Company profile save failed', e.response?.data || e.message); }
//         navigate('/employer/jobs');
//         return;
//       }

//       try {
//         await api.put('/profile', {
//           name: form.name,
//           gender: form.gender ? form.gender.toLowerCase() : '',
//           city: form.locations[0] || '',
//           career_objective: [
//             form.experienceLevel === 'fresher' ? `Looking for: ${form.lookingForRole}` : `Looking for: ${form.targetRole}`,
//             form.locations.length ? `Preferred locations: ${form.locations.join(', ')}` : '',
//           ].filter(Boolean).join(' — '),
//         });
//       } catch (e) { console.warn('Profile save failed', e.response?.data || e.message); }

//       await Promise.allSettled(form.skills.map((skill_name) => api.post('/skills', { skill_name, proficiency: 'intermediate' })));

//       if (form.experienceLevel === 'experienced') {
//         const startDate = form.startYear && form.startMonth ? `${form.startYear}-${String(MONTHS.indexOf(form.startMonth) + 1).padStart(2, '0')}-01` : null;
//         const endDate = !form.currentlyWorking && form.endYear && form.endMonth
//           ? `${form.endYear}-${String(MONTHS.indexOf(form.endMonth) + 1).padStart(2, '0')}-01` : null;
//         const savers = [
//           api.post('/experiences', {
//             job_title: form.currentDesignation, company_name: form.currentCompany,
//             start_date: startDate, end_date: endDate, currently_working: form.currentlyWorking,
//             description: form.currentSalary ? `Salary: ₹${form.currentSalary}/${form.salaryPeriod}` : '',
//           }),
//           ...form.previousEmployers.map((p) => api.post('/experiences', {
//             job_title: p.designation, company_name: p.company, start_date: p.from || null,
//             end_date: p.to || null, currently_working: false, description: '',
//           })),
//         ];
//         await Promise.allSettled(savers);
//       }

//       navigate('/dashboard');
//     } catch (err) {
//       setError(err.response?.data?.message || 'Registration failed. Please try again.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   /* ---------------------------------------------------------------------- */
//   /* Composer                                                                 */
//   /* ---------------------------------------------------------------------- */

//   const composer = () => {
//     switch (step) {
//       case 'welcome':
//         return <PrimaryButton onClick={handleGetStarted}>Get Started →</PrimaryButton>;

//       case 'name':
//         return <TextComposer value={draft} onChange={setDraft} onSubmit={submitName} placeholder="Enter your full name" autoFocus />;

//       case 'gender':
//         return (
//           <div className="flex flex-wrap gap-2">
//             {['Male', 'Female', 'Other', 'Prefer not to say'].map((g, i) => (
//               <PillOption key={g} label={g} tileIndex={i} onClick={() => submitGender(g)} />
//             ))}
//           </div>
//         );

//       case 'phone':
//         return (
//           <div className="flex items-center gap-2">
//             <span className="px-3 py-2.5 text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-full">+91</span>
//             <TextComposer value={draft} onChange={(v) => setDraft(v.replace(/\D/g, '').slice(0, 10))} onSubmit={submitPhone} placeholder="98765 43210" type="tel" autoFocus />
//             {sendingOtp && <span className="text-xs text-gray-400">Sending…</span>}
//           </div>
//         );

//       case 'otp':
//         return (
//           <div>
//             <div className="flex gap-2.5 justify-center mb-3">
//               {otpDigits.map((d, i) => (
//                 <input
//                   key={i} ref={(el) => (otpRefs.current[i] = el)} type="tel" inputMode="numeric" maxLength={1}
//                   value={d} onChange={(e) => handleOtpDigit(i, e.target.value)} onKeyDown={(e) => handleOtpKeyDown(i, e)}
//                   autoFocus={i === 0}
//                   className="w-11 h-12 text-center text-lg font-bold border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#2563EB] focus:ring-2 focus:ring-[#2563EB]/20 bg-white transition"
//                 />
//               ))}
//             </div>
//             <div className="text-center text-xs text-gray-500 mb-3">
//               {resendCooldown > 0 ? <span>Didn't receive OTP? Resend in {resendCooldown}s</span> :
//                 <button type="button" onClick={handleResendOtp} className="text-[#2563EB] font-semibold hover:underline">Resend OTP</button>}
//             </div>
//             <PrimaryButton onClick={submitOtp} disabled={verifyingOtp}>{verifyingOtp ? 'Verifying…' : 'Verify OTP'}</PrimaryButton>
//           </div>
//         );

//       case 'account':
//         return (
//           <div className="space-y-2.5">
//             <input type="email" value={form.email} onChange={(e) => set({ email: e.target.value })} placeholder="you@example.com"
//               className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <input type="password" value={form.password} onChange={(e) => set({ password: e.target.value })} placeholder="Password (min 8 characters)"
//               className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <input type="password" value={form.password_confirmation} onChange={(e) => set({ password_confirmation: e.target.value })} placeholder="Confirm password"
//               className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <PrimaryButton onClick={submitAccount}>Continue</PrimaryButton>
//           </div>
//         );

//       case 'role':
//         return (
//           <div className="flex gap-3">
//             <TileCard icon="👤" title="I'm looking for a Job" subtitle="Find jobs & get hired" tileIndex={0} onClick={() => submitRole('job_seeker')} />
//             <TileCard icon="🏢" title="I'm hiring" subtitle="Find candidates & hire" tileIndex={1} onClick={() => submitRole('employer')} />
//           </div>
//         );

//       case 'exp_level':
//         return (
//           <div className="flex gap-3">
//             <TileCard icon="🌱" title="Fresher" tileIndex={2} onClick={() => submitExpLevel('fresher')} />
//             <TileCard icon="💼" title="Experienced" tileIndex={0} onClick={() => submitExpLevel('experienced')} />
//           </div>
//         );

//       case 'looking_role':
//         return <InlineAutocomplete options={JOB_TITLES_LIST} value={draft} onChange={setDraft} onSelect={(v) => { setDraft(''); submitLookingRole(v); }} placeholder="Search for a role (e.g. Software Developer)" />;

//       case 'current_designation':
//         return <InlineAutocomplete options={JOB_TITLES_LIST} value={draft} onChange={setDraft} onSelect={(v) => { setDraft(''); submitCurrentDesignation(v); }} placeholder="e.g. Software Developer" />;

//       case 'current_salary':
//         return (
//           <div className="flex items-center gap-2">
//             <span className="px-3 py-2.5 text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-full">₹</span>
//             <input type="number" value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Amount"
//               className="flex-1 border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <select value={form.salaryPeriod} onChange={(e) => set({ salaryPeriod: e.target.value })} className="border border-gray-200 rounded-full px-3 py-2.5 text-sm bg-white">
//               <option value="month">Per month</option>
//               <option value="year">Per year</option>
//             </select>
//             <button type="button" onClick={submitCurrentSalary} disabled={!draft.trim()}
//               className="w-10 h-10 rounded-full bg-gradient-to-br from-[#2563EB] to-[#3B82F6] text-white flex items-center justify-center shrink-0 shadow-md hover:scale-105 active:scale-95 transition disabled:opacity-40 disabled:hover:scale-100">➤</button>
//           </div>
//         );

//       case 'current_company':
//         return <TextComposer value={draft} onChange={setDraft} onSubmit={() => { const v = draft; setDraft(''); submitCurrentCompany(v); }} placeholder="Company name" autoFocus />;

//       case 'employment_period':
//         return (
//           <div className="space-y-3">
//             <div className="grid grid-cols-2 gap-2">
//               <select value={form.startMonth} onChange={(e) => set({ startMonth: e.target.value })} className="border border-gray-200 rounded-full px-3 py-2.5 text-sm bg-white">
//                 <option value="">Start month</option>{MONTHS.map((m) => <option key={m} value={m}>{m}</option>)}
//               </select>
//               <select value={form.startYear} onChange={(e) => set({ startYear: e.target.value })} className="border border-gray-200 rounded-full px-3 py-2.5 text-sm bg-white">
//                 <option value="">Start year</option>{YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
//               </select>
//             </div>
//             <label className="flex items-center gap-2 text-sm text-gray-600 px-1">
//               <input type="checkbox" checked={form.currentlyWorking} onChange={(e) => set({ currentlyWorking: e.target.checked })} className="accent-[#2563EB]" />
//               I currently work here
//             </label>
//             {!form.currentlyWorking && (
//               <div className="grid grid-cols-2 gap-2">
//                 <select value={form.endMonth} onChange={(e) => set({ endMonth: e.target.value })} className="border border-gray-200 rounded-full px-3 py-2.5 text-sm bg-white">
//                   <option value="">End month</option>{MONTHS.map((m) => <option key={m} value={m}>{m}</option>)}
//                 </select>
//                 <select value={form.endYear} onChange={(e) => set({ endYear: e.target.value })} className="border border-gray-200 rounded-full px-3 py-2.5 text-sm bg-white">
//                   <option value="">End year</option>{YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
//                 </select>
//               </div>
//             )}
//             <PrimaryButton onClick={submitEmploymentPeriod}>Continue</PrimaryButton>
//           </div>
//         );

//       case 'prev_employer_choice':
//         return (
//           <div className="flex gap-3">
//             <button type="button" onClick={() => submitPrevChoice(true)} className="flex-1 border-2 border-[#2563EB] text-[#2563EB] py-2.5 rounded-full font-semibold text-sm hover:bg-[#EFF6FF] transition">Yes, add previous employer</button>
//             <button type="button" onClick={() => submitPrevChoice(false)} className="flex-1 bg-gradient-to-r from-[#2563EB] to-[#3B82F6] text-white py-2.5 rounded-full font-semibold text-sm shadow-md hover:shadow-lg transition">No, continue</button>
//           </div>
//         );

//       case 'prev_employer_add':
//         return (
//           <div className="space-y-2.5">
//             <input type="text" value={prevDraft.company} onChange={(e) => setPrevDraft((p) => ({ ...p, company: e.target.value }))} placeholder="Company"
//               className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <input type="text" value={prevDraft.designation} onChange={(e) => setPrevDraft((p) => ({ ...p, designation: e.target.value }))} placeholder="Designation"
//               className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <div className="grid grid-cols-2 gap-2">
//               <input type="text" value={prevDraft.from} onChange={(e) => setPrevDraft((p) => ({ ...p, from: e.target.value }))} placeholder="From (e.g. 2020)"
//                 className="border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//               <input type="text" value={prevDraft.to} onChange={(e) => setPrevDraft((p) => ({ ...p, to: e.target.value }))} placeholder="To (e.g. 2022)"
//                 className="border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             </div>
//             <PrimaryButton onClick={submitPrevEmployer}>Add</PrimaryButton>
//           </div>
//         );

//       case 'prev_employer_more':
//         return (
//           <div className="flex gap-3">
//             <button type="button" onClick={() => submitPrevMore(true)} className="flex-1 border-2 border-[#2563EB] text-[#2563EB] py-2.5 rounded-full font-semibold text-sm hover:bg-[#EFF6FF] transition">+ Add another</button>
//             <button type="button" onClick={() => submitPrevMore(false)} className="flex-1 bg-gradient-to-r from-[#2563EB] to-[#3B82F6] text-white py-2.5 rounded-full font-semibold text-sm shadow-md hover:shadow-lg transition">Continue</button>
//           </div>
//         );

//       case 'target_role':
//         return <InlineAutocomplete options={JOB_TITLES_LIST} value={draft} onChange={setDraft} onSelect={(v) => { setDraft(''); submitTargetRole(v); }} placeholder="e.g. Software Developer" />;

//       case 'locations':
//         return (
//           <div>
//             {form.locations.length > 0 && (
//               <div className="flex flex-wrap gap-2 mb-2">{form.locations.map((l, i) => <Chip key={l} label={l} onRemove={() => removeLocation(i)} />)}</div>
//             )}
//             <p className="text-xs text-gray-400 mb-2 px-1">{form.locations.length}/{MAX_LOCATIONS} locations selected</p>
//             {form.locations.length < MAX_LOCATIONS && (
//               <InlineAutocomplete options={CITIES_LIST} value={locInput} onChange={setLocInput} onSelect={addLocation} placeholder="Add a city" />
//             )}
//             <div className="mt-3"><PrimaryButton onClick={submitLocations}>Continue</PrimaryButton></div>
//           </div>
//         );

//       case 'skills':
//         return (
//           <div>
//             {form.skills.length > 0 && (
//               <div className="flex flex-wrap gap-2 mb-2">{form.skills.map((s, i) => <Chip key={s} label={s} onRemove={() => removeSkill(i)} />)}</div>
//             )}
//             <InlineAutocomplete options={SKILLS_LIST} value={skillInput} onChange={setSkillInput} onSelect={addSkill} placeholder="Type a skill and select" />
//             <div className="mt-3"><PrimaryButton onClick={submitSkills}>Continue</PrimaryButton></div>
//           </div>
//         );

//       case 'employer_company':
//         return (
//           <div className="space-y-2.5">
//             <input type="text" value={form.company_industry} onChange={(e) => set({ company_industry: e.target.value })} placeholder="Industry (e.g. IT Services)"
//               className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB] bg-white transition" />
//             <select value={form.company_size} onChange={(e) => set({ company_size: e.target.value })} className="w-full border border-gray-200 rounded-full px-4 py-2.5 text-sm bg-white">
//               <option value="">Company size</option>
//               {['1-10', '11-50', '51-200', '201-500', '501-1000', '1000+'].map((s) => <option key={s} value={s}>{s}</option>)}
//             </select>
//             <PrimaryButton onClick={submitEmployerCompany}>Continue</PrimaryButton>
//           </div>
//         );

//       case 'summary': {
//         const rows = form.role === 'employer'
//           ? [['Name', form.name], ['Industry', form.company_industry], ['Company size', form.company_size]]
//           : [
//               ['Name', form.name], ['Gender', form.gender],
//               ['Experience', form.experienceLevel === 'fresher' ? 'Fresher' : 'Experienced'],
//               ...(form.experienceLevel === 'fresher'
//                 ? [['Looking for', form.lookingForRole]]
//                 : [['Current', `${form.currentDesignation} · ${form.currentCompany}`], ['Looking for', form.targetRole]]),
//               ['Preferred locations', form.locations.join(', ')],
//               ['Skills', form.skills.join(', ')],
//             ];
//         return (
//           <div>
//             <div className="rounded-2xl mb-4 bg-white shadow-sm border border-gray-100 overflow-hidden divide-y divide-gray-50">
//               {rows.map(([label, value]) => (
//                 <div key={label} className="flex justify-between px-4 py-2.5 text-sm gap-3">
//                   <span className="text-gray-500 shrink-0">{label}</span>
//                   <span className="font-semibold text-[#0D1B3D] text-right">{value || '-'}</span>
//                 </div>
//               ))}
//             </div>
//             <PrimaryButton onClick={completeProfile} disabled={submitting}>{submitting ? 'Creating account…' : '🎉 Complete Profile'}</PrimaryButton>
//           </div>
//         );
//       }
//       default:
//         return null;
//     }
//   };

//   const order = stepOrderFor(form.role, form.experienceLevel);
//   const idx = Math.max(order.indexOf(step), 0);
//   const progressPct = Math.min(100, Math.round(((idx + 1) / order.length) * 100));

//   /* ---------------------------------------------------------------------- */

//   return (
//     <div className="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-[#0D1B3D] py-6 px-3">
//       <GlobalStyles />

//       {/* Decorative gradient backdrop */}
//       <div className="absolute inset-0 bg-gradient-to-br from-[#0D1B3D] via-[#1E1042] to-[#3B1F70]" />
//       <div className="rc-blob absolute -top-32 -left-24 w-96 h-96 bg-[#E3242B]/25 rounded-full blur-[100px]" />
//       <div className="rc-blob absolute -bottom-32 -right-16 w-96 h-96 bg-[#2563EB]/25 rounded-full blur-[100px]" style={{ animationDelay: '2s' }} />
//       <div className="rc-blob absolute top-1/3 right-1/4 w-72 h-72 bg-[#6B2A8C]/20 rounded-full blur-[90px]" style={{ animationDelay: '4s' }} />

//       {/* "Device" card */}
//       <div className="relative z-10 w-full max-w-md h-[92vh] max-h-[820px] bg-[#F9FAFB] rounded-[2rem] shadow-2xl flex flex-col overflow-hidden ring-1 ring-white/10">
//         {/* Header */}
//         <div className="flex items-center gap-2.5 px-5 py-4 bg-white border-b border-gray-100 shrink-0">
//           <img src={planbLogo} alt="PlanB Jobs" className="h-7 w-auto" />
//           <span className="font-bold text-[#0D1B3D] text-sm">PlanB Jobs</span>
//           <span className="ml-auto text-[11px] font-semibold text-gray-400">{progressPct}%</span>
//         </div>
//         {/* Progress trail */}
//         <div className="h-1 bg-gray-100 shrink-0">
//           <div
//             className="h-full bg-gradient-to-r from-[#2563EB] via-[#6B2A8C] to-[#E3242B] transition-all duration-500"
//             style={{ width: `${progressPct}%` }}
//           />
//         </div>

//         {/* Conversation */}
//         <div ref={scrollRef} className="flex-1 overflow-y-auto px-4 py-5">
//           {messages.map((m) => (m.from === 'bot' ? <BotBubble key={m.id}>{m.content}</BotBubble> : <UserBubble key={m.id}>{m.content}</UserBubble>))}
//           {typing && <TypingBubble />}
//         </div>

//         {error && (
//           <div className="mx-4 mb-2 bg-red-50 text-red-600 border border-red-100 px-3 py-2 rounded-xl text-xs shrink-0">{error}</div>
//         )}

//         {!typing && (
//           <div className="rc-composer border-t border-gray-100 bg-white px-4 py-3.5 shrink-0">
//             {composer()}
//           </div>
//         )}

//         <p className="text-center text-xs text-gray-400 py-2.5 bg-white border-t border-gray-50 shrink-0">
//           Already have an account?{' '}
//           <Link to="/login" className="text-[#2563EB] font-semibold hover:underline">Login</Link>
//         </p>
//       </div>
//     </div>
//   );
// }

// export default RegisterChat;